'use client';

import type { ReactNode } from 'react';
import { VStack, Box } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { Database01Icon } from '@terra/ui-icons';
import { Card } from '../../../components/card';
import { Skeleton } from '../../../components/skeleton';
import { SettingsEmptyState } from '../../settings/SettingsEmptyState';

export function EntityContainer({ children }: { children: ReactNode }) {
  return (
    <Card.Root
      w="full"
      bg="bg.neutral.default"
      borderWidth="1px"
      borderColor="border.neutral.subtle"
      borderRadius="lg"
      shadow="none"
      overflow="hidden"
      p={4}
    >
      {children}
    </Card.Root>
  );
}

export function SkeletonList({
  count = 4,
  height = '56px',
}: {
  count?: number;
  height?: string;
}) {
  return (
    <VStack gap={0} alignItems="stretch">
      {Array.from({ length: count }).map((_, idx) => (
        <Box
          key={idx}
          px={4}
          py={3}
          borderBottomWidth={idx < count - 1 ? '1px' : 0}
          borderBottomColor="border.neutral.default"
        >
          <Skeleton h={height} w="full" borderRadius="sm" />
        </Box>
      ))}
    </VStack>
  );
}

export function ScopeEmptyState() {
  const t = useTranslations('designSystem.networkSettings.externalScope');

  return (
    <SettingsEmptyState icon={<Database01Icon size={22} opacity={0.25} />}>
      {t('noEntities')}
    </SettingsEmptyState>
  );
}
